<template>
  <div class="dp-wrap">
    <!-- Topo -->
    <div class="dp-header vm-page-header">
      <div>
        <h1>Perfil e configurações</h1>
        <span class="vm-page-header__sub">
          Gerencie seus dados, perfil profissional e preferências de
          atendimento.
        </span>
      </div>
    </div>

    <div class="dp-body">
      <!-- SUB-NAV -->
      <nav class="card acct-nav">
        <a
          href="#dados"
          :class="{ on: activeNav === 'dados' }"
          @click="activeNav = 'dados'"
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
            <circle
              cx="12"
              cy="8"
              r="4"
              stroke="currentColor"
              stroke-width="2"
            />
            <path
              d="M4 21c0-4 4-6 8-6s8 2 8 6"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
            />
          </svg>
          Dados pessoais
        </a>
        <a
          href="#prof"
          :class="{ on: activeNav === 'prof' }"
          @click="activeNav = 'prof'"
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
            <path
              d="M9 3h6v3h4a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4z"
              stroke="currentColor"
              stroke-width="2"
              stroke-linejoin="round"
            />
          </svg>
          Perfil profissional
        </a>
        <a
          href="#atend"
          :class="{ on: activeNav === 'atend' }"
          @click="activeNav = 'atend'"
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
            <path
              d="M12 2v20M17 6H9.5a3.5 3.5 0 100 7h5a3.5 3.5 0 110 7H6"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
            />
          </svg>
          Atendimento
        </a>
        <a
          href="#notif"
          :class="{ on: activeNav === 'notif' }"
          @click="activeNav = 'notif'"
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
            <path
              d="M18 8a6 6 0 0 0-12 0c0 7-3 9-3 9h18s-3-2-3-9"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M10.3 21a1.94 1.94 0 0 0 3.4 0"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
            />
          </svg>
          Notificações
        </a>
        <a
          href="#seg"
          :class="{ on: activeNav === 'seg' }"
          @click="activeNav = 'seg'"
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
            <rect
              x="4"
              y="10"
              width="16"
              height="11"
              rx="2"
              stroke="currentColor"
              stroke-width="2"
            />
            <path
              d="M8 10V7a4 4 0 0 1 8 0v3"
              stroke="currentColor"
              stroke-width="2"
            />
          </svg>
          Segurança
        </a>
      </nav>

      <!-- CONTEÚDO -->
      <div class="acct-main">
        <!-- DADOS PESSOAIS -->
        <section class="card acct-sec" id="dados">
          <h2>Dados pessoais</h2>
          <p class="sub">
            Dados usados para identificação e emissão de documentos.
          </p>
          <div class="acct-id">
            <div
              class="avatar avatar--xl avatar--ring"
              :class="{ 'avatar--accent': !currentUser.photo }"
              :style="
                currentUser.photo
                  ? `background-image:url(${currentUser.photo});background-size:cover;background-position:center;`
                  : ''
              "
            >
              <span v-if="!currentUser.photo">{{ userInitials }}</span>
            </div>
            <div class="stack" style="gap:var(--space-2)">
              <span
                style="font-size:var(--font-size-lg);font-weight:var(--fw-bold);color:var(--color-gray-900)"
              >
                {{ currentUser.name }}
              </span>
              <button
                class="btn btn--outline btn--sm"
                style="align-self:flex-start"
                @click="$bvModal.show('avatarModal')"
              >
                Alterar foto
              </button>
            </div>
          </div>
          <div class="form-grid">
            <div class="field">
              <label class="label">Nome completo</label>
              <input class="input" v-model="formUser.name" />
            </div>
            <div class="field">
              <label class="label">CPF</label>
              <input
                class="input num"
                :value="formattedCpf"
                readonly
                style="background:var(--color-gray-50);color:var(--color-gray-500)"
              />
            </div>
            <div class="field">
              <label class="label">E-mail</label>
              <input class="input" type="email" v-model="formUser.email" />
            </div>
            <div class="field">
              <label class="label">Telefone</label>
              <input
                class="input num"
                type="tel"
                v-model="formUser.phone_number"
                v-mask="'(##) #####-####'"
              />
            </div>
            <div class="field">
              <label class="label">Data de nascimento</label>
              <input
                class="input num"
                v-model="formUser.birthday"
                v-mask="'##/##/####'"
                placeholder="DD/MM/AAAA"
              />
            </div>
            <div class="field">
              <label class="label">Gênero</label>
              <select class="select" v-model="formUser.gender">
                <option value="">Selecione</option>
                <option value="female">Feminino</option>
                <option value="male">Masculino</option>
                <option value="prefer_not_to_say">Prefiro não informar</option>
              </select>
            </div>
          </div>
          <div class="row" style="gap:var(--space-3);margin-top:var(--space-5)">
            <button class="btn btn--primary" @click="saveUser">
              Salvar alterações
            </button>
            <button class="btn btn--ghost" @click="resetUserForm">
              Cancelar
            </button>
          </div>
        </section>

        <!-- PERFIL PROFISSIONAL -->
        <section class="card acct-sec" id="prof">
          <h2>Perfil profissional</h2>
          <p class="sub">
            Informações exibidas para os pacientes na busca e no seu perfil
            público.
          </p>
          <div class="form-grid">
            <div class="field">
              <label class="label">Especialidade principal</label>
              <input
                class="input"
                :value="dp.medical_specialty_name || dp.speciality_name || ''"
                readonly
                style="background:var(--color-gray-50);color:var(--color-gray-500)"
              />
            </div>
            <div class="field">
              <label class="label">CRM</label>
              <input
                class="input num"
                :value="dp.council_description || ''"
                readonly
                style="background:var(--color-gray-50);color:var(--color-gray-500)"
              />
              <span class="hint">
                Validado junto ao conselho · não editável
              </span>
            </div>
            <div class="field" v-if="isPhysicianCouncil">
              <label class="label">RQE (registro de especialista)</label>
              <input class="input num" v-model="formDoctor.rqe" />
            </div>
            <div class="field">
              <label class="label">UF de registro</label>
              <input
                class="input"
                :value="dp.council_uf || ''"
                readonly
                style="background:var(--color-gray-50);color:var(--color-gray-500)"
              />
            </div>
            <div class="field full">
              <label class="label">Biografia</label>
              <textarea
                class="input dp-textarea"
                v-model="formDoctor.biography"
                maxlength="400"
              />
              <span class="charcount">
                {{ (formDoctor.biography || "").length }} / 400
              </span>
            </div>
            <div class="field full">
              <label class="label">Idiomas de atendimento</label>
              <div class="chip-row">
                <span
                  v-for="lang in formDoctor.languages"
                  :key="lang"
                  class="chip"
                >
                  {{ lang }}
                  <span class="chip-x" @click="removeLanguage(lang)">×</span>
                </span>
                <button
                  class="btn btn--ghost btn--sm"
                  type="button"
                  @click="addLanguagePrompt"
                >
                  + Adicionar
                </button>
              </div>
            </div>
            <div class="field full">
              <label class="label">Formação e experiência</label>
              <div class="formation-list">
                <div
                  v-for="(entry, index) in formDoctor.formationEntries"
                  :key="entry.id || `new-${index}`"
                  class="formation-row"
                >
                  <input
                    class="input formation-row__year"
                    v-model="entry.period"
                    placeholder="Ano"
                  />
                  <input
                    class="input formation-row__title"
                    v-model="entry.title"
                    placeholder="Título"
                  />
                  <input
                    class="input formation-row__institution"
                    v-model="entry.institution"
                    placeholder="Instituição"
                  />
                  <button
                    class="btn btn--outline btn--sm"
                    type="button"
                    @click="saveFormationEntry(entry)"
                  >
                    Salvar
                  </button>
                  <button
                    class="btn btn--ghost btn--sm"
                    type="button"
                    @click="askRemoveFormationEntry(entry)"
                  >
                    Remover
                  </button>
                </div>
              </div>
              <button
                class="btn btn--ghost btn--sm"
                type="button"
                @click="addFormationRow"
              >
                + Adicionar formação
              </button>
            </div>

            <div class="field full">
              <label class="label">Condições atendidas</label>
              <div class="chip-row">
                <span
                  v-for="condition in formDoctor.conditionEntries"
                  :key="condition.id || condition.name"
                  class="chip"
                >
                  {{ condition.name }}
                  <span class="chip-x" @click="askRemoveCondition(condition)">
                    ×
                  </span>
                </span>
              </div>
              <div class="inline-add-row">
                <template v-if="addingCondition">
                  <input
                    class="input"
                    v-model="newConditionName"
                    placeholder="Nova condição"
                    @keyup.enter="confirmAddCondition"
                    @keyup.esc="cancelAddCondition"
                  />
                  <button
                    class="btn btn--primary btn--sm"
                    type="button"
                    @click="confirmAddCondition"
                  >
                    Salvar
                  </button>
                  <button
                    class="btn btn--ghost btn--sm"
                    type="button"
                    @click="cancelAddCondition"
                  >
                    Cancelar
                  </button>
                </template>
                <button
                  v-else
                  class="btn btn--ghost btn--sm"
                  type="button"
                  @click="addCondition"
                >
                  + Adicionar
                </button>
              </div>
            </div>
          </div>
          <div class="row" style="gap:var(--space-3);margin-top:var(--space-5)">
            <button class="btn btn--primary" @click="saveDoctorProfile">
              Salvar alterações
            </button>
            <button class="btn btn--ghost" @click="resetDoctorForm">
              Cancelar
            </button>
          </div>
        </section>

        <!-- ATENDIMENTO -->
        <section class="card acct-sec" id="atend">
          <h2>Atendimento</h2>
          <p class="sub">Valor, duração e modalidade das suas consultas.</p>
          <div class="form-grid">
            <div class="field">
              <label class="label">Valor da consulta (R$)</label>
              <input
                class="input num"
                v-model="formDoctor.price_cents"
                placeholder="0,00"
              />
              <span class="hint">
                A plataforma retém a taxa de serviço; você recebe o repasse
                líquido.
              </span>
            </div>
            <div class="field">
              <label class="label">Duração padrão</label>
              <select class="select" v-model="formDoctor.duration">
                <option value="30">30 minutos</option>
                <option value="40">40 minutos</option>
                <option value="50">50 minutos</option>
                <option value="60">60 minutos</option>
              </select>
            </div>
          </div>
          <div style="margin-top:var(--space-3)">
            <div class="setting-row">
              <div class="tx">
                <b>Teleconsulta (vídeo)</b>
                <span>Atendimento por vídeo dentro da Videomedi</span>
              </div>
              <label class="toggle">
                <input type="checkbox" v-model="formDoctor.teleconsulta" />
                <span class="track" />
              </label>
            </div>
            <div class="setting-row">
              <div class="tx">
                <b>Retorno gratuito em até 15 dias</b>
                <span>Permite que o paciente agende um retorno sem custo</span>
              </div>
              <label class="toggle">
                <input type="checkbox" v-model="formDoctor.free_return" />
                <span class="track" />
              </label>
            </div>
            <div class="setting-row">
              <div class="tx">
                <b>Aceitar novos pacientes</b>
                <span>Quando desligado, seu perfil não aparece na busca</span>
              </div>
              <label class="toggle">
                <input
                  type="checkbox"
                  v-model="formDoctor.accept_new_patients"
                />
                <span class="track" />
              </label>
            </div>
          </div>
          <div class="row" style="gap:var(--space-3);margin-top:var(--space-5)">
            <button class="btn btn--primary" @click="saveDoctorProfile">
              Salvar alterações
            </button>
            <button class="btn btn--ghost" @click="resetDoctorForm">
              Cancelar
            </button>
          </div>
        </section>

        <!-- NOTIFICAÇÕES -->
        <section class="card acct-sec" id="notif">
          <h2>Notificações</h2>
          <p class="sub">
            Escolha como quer ser avisado sobre sua agenda e atendimentos.
          </p>
          <div class="setting-row">
            <div class="tx">
              <b>Novos agendamentos</b>
              <span>Aviso assim que um paciente marca uma consulta</span>
            </div>
            <label class="toggle">
              <input type="checkbox" v-model="notif.new_appointments" />
              <span class="track" />
            </label>
          </div>
          <div class="setting-row">
            <div class="tx">
              <b>Lembretes de consulta</b>
              <span>Aviso 1h antes de cada atendimento</span>
            </div>
            <label class="toggle">
              <input type="checkbox" v-model="notif.reminders" />
              <span class="track" />
            </label>
          </div>
          <div class="setting-row">
            <div class="tx">
              <b>Cancelamentos e remarcações</b>
              <span>Notificação quando o paciente altera o horário</span>
            </div>
            <label class="toggle">
              <input type="checkbox" v-model="notif.cancellations" />
              <span class="track" />
            </label>
          </div>
          <div class="setting-row">
            <div class="tx">
              <b>E-mail</b>
              <span>Resumo diário da agenda e recibos de repasse</span>
            </div>
            <label class="toggle">
              <input type="checkbox" v-model="notif.email" />
              <span class="track" />
            </label>
          </div>
          <div class="setting-row">
            <div class="tx">
              <b>SMS</b>
              <span>Lembretes por mensagem de texto</span>
            </div>
            <label class="toggle">
              <input type="checkbox" v-model="notif.sms" />
              <span class="track" />
            </label>
          </div>
        </section>

        <!-- SEGURANÇA -->
        <section class="card acct-sec" id="seg">
          <h2>Segurança</h2>
          <p class="sub">
            Proteja o acesso à sua conta e aos dados dos seus pacientes.
          </p>
          <div class="setting-row">
            <div class="tx">
              <b>Senha</b>
              <span>Atualize para manter sua conta segura</span>
            </div>
            <button
              class="btn btn--outline btn--sm"
              @click="showPasswordForm = !showPasswordForm"
            >
              Alterar senha
            </button>
          </div>
          <PasswordForm v-if="showPasswordForm" />
          <div class="setting-row">
            <div class="tx">
              <b>Verificação em duas etapas</b>
              <span>Código por SMS ao entrar em um novo dispositivo</span>
            </div>
            <label class="toggle">
              <input type="checkbox" v-model="twoFactor" />
              <span class="track" />
            </label>
          </div>
          <div class="setting-row">
            <div class="tx">
              <b>Privacidade e LGPD</b>
              <span>Baixe ou exclua seus dados</span>
            </div>
            <button class="btn btn--ghost btn--sm" disabled>
              Gerenciar
            </button>
          </div>
          <div class="setting-row">
            <div class="tx">
              <b>Desativar conta</b>
              <span>Desative temporariamente o acesso à sua conta</span>
            </div>
            <button
              class="btn btn--danger btn--sm"
              @click="$bvModal.show('confirmationModal')"
            >
              Desativar
            </button>
          </div>
        </section>
      </div>
    </div>

    <!-- Modal: alterar foto -->
    <BModal
      id="avatarModal"
      hide-footer
      centered
      title="Alterar foto de perfil"
    >
      <AvatarForm />
    </BModal>

    <!-- Modal: confirmar remoção de condição atendida -->
    <BModal
      id="removeConditionModal"
      ref="removeConditionModal"
      hide-footer
      hide-header
      centered
    >
      <div class="p-5">
        <h4 class="title-2 text-color-secondary text-center mb-4">
          Remover
          <strong>{{ conditionToRemove && conditionToRemove.name }}</strong>
          das condições atendidas?
        </h4>
        <BButton
          class="button2 mb-2"
          block
          style="background-color:var(--color-accent); color:#fff"
          @click="confirmRemoveCondition"
        >
          Confirmar
        </BButton>
        <BButton
          class="button2 mb-2"
          block
          @click="$bvModal.hide('removeConditionModal')"
        >
          Cancelar
        </BButton>
      </div>
    </BModal>

    <!-- Modal: confirmar remoção de formação -->
    <BModal
      id="removeFormationEntryModal"
      ref="removeFormationEntryModal"
      hide-footer
      hide-header
      centered
    >
      <div class="p-5">
        <h4 class="title-2 text-color-secondary text-center mb-4">
          Remover
          <strong>
            {{ formationEntryToRemove && formationEntryToRemove.title }}
          </strong>
          da formação e experiência?
        </h4>
        <BButton
          class="button2 mb-2"
          block
          style="background-color:var(--color-accent); color:#fff"
          @click="confirmRemoveFormationEntry"
        >
          Confirmar
        </BButton>
        <BButton
          class="button2 mb-2"
          block
          @click="$bvModal.hide('removeFormationEntryModal')"
        >
          Cancelar
        </BButton>
      </div>
    </BModal>

    <!-- Modal: confirmar exclusão de conta -->
    <BModal
      id="confirmationModal"
      ref="confirmationModal"
      hide-footer
      hide-header
      centered
    >
      <div class="p-5">
        <h4 class="title-2 text-color-secondary text-center mb-2">
          Ficamos tristes em saber que você vai nos deixar, não quer nos dar
          outra chance?
        </h4>
        <p class="title-2 text-color-secondary text-center mb-2">
          Se estiver mesmo decidido em desativar sua conta, basta clicar no
          botão Confirmar.
        </p>
        <p
          class="title-2 text-color-secondary text-center font-weight-bold mb-2"
        >
          Atenção: Seus dados ficarão preservados na plataforma. Quando você
          optar por voltar, basta logar novamente.
        </p>
        <p class="title-2 text-color-secondary text-center mb-4">
          Esperamos te ver em breve!
        </p>
        <BButton
          class="button2 mb-2"
          block
          style="background-color:var(--color-accent); color:#fff"
          @click="deleteAccount"
        >
          Confirmar
        </BButton>
        <BButton
          class="button2 mb-2"
          block
          @click="$bvModal.hide('confirmationModal')"
        >
          Cancelar
        </BButton>
      </div>
    </BModal>

    <BModal
      id="accountDeleted"
      ref="accountDeleted"
      hide-footer
      hide-header
      centered
    >
      <div class="p-5">
        <h4 class="title-2 text-color-secondary text-center mb-4">
          Sua conta foi desativada
        </h4>
      </div>
    </BModal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import PasswordForm from "../components/PasswordForm.vue";
import AvatarForm from "../components/AvatarForm.vue";
import { Doctor } from "../services/doctor";

export default {
  name: "DoctorProfileView",
  components: { PasswordForm, AvatarForm },

  data() {
    return {
      activeNav: "dados",
      showPasswordForm: false,
      twoFactor: false,
      formUser: {
        name: "",
        email: "",
        phone_number: "",
        birthday: "",
        gender: ""
      },
      formDoctor: {
        price_cents: "",
        duration: "30",
        teleconsulta: true,
        free_return: true,
        accept_new_patients: true,
        biography: "",
        rqe: "",
        languages: ["Português"],
        conditionEntries: [],
        formationEntries: []
      },
      addingCondition: false,
      newConditionName: "",
      conditionToRemove: null,
      formationEntryToRemove: null,
      notif: {
        new_appointments: true,
        reminders: true,
        cancellations: true,
        email: true,
        sms: false
      }
    };
  },

  mounted() {
    document.body.className = "";
    document.body.classList.add("doctor-app-body");

    // Busca o usuário atualizado no backend ao entrar na tela — sem isso, o
    // formulário mostra só o que já estava salvo na store (vuex-persistedstate
    // guarda isso em sessionStorage), então formações/condições cadastradas
    // em outra sessão, ou por qualquer outra via, não apareceriam aqui.
    if (this.currentUser.id) {
      this.showUser(this.currentUser.id);
    }
  },

  methods: {
    ...mapActions("user", ["updateUser", "showUser"]),
    ...mapActions("doctor", ["updateDoctorProperties"]),
    ...mapActions("auth", ["logout", "clearLocalSession"]),

    toDisplayDate(iso) {
      if (!iso || iso.length !== 10) return iso || "";
      const [y, m, d] = iso.split("-");
      return y && m && d ? `${d}/${m}/${y}` : iso;
    },

    toIsoDate(br) {
      if (!br || br.length !== 10) return br || "";
      const [d, m, y] = br.split("/");
      return d && m && y ? `${y}-${m}-${d}` : br;
    },

    resetUserForm() {
      const u = this.currentUser || {};
      this.formUser = {
        name: u.name || "",
        email: u.email || "",
        phone_number: u.phone_number || "",
        birthday: this.toDisplayDate(u.birthday),
        gender: u.gender || ""
      };
    },

    resetDoctorForm() {
      const dp = this.dp || {};
      this.formDoctor = {
        price_cents: dp.price_cents || "",
        duration: dp.duration || "30",
        teleconsulta: true,
        free_return: true,
        accept_new_patients: true,
        biography: dp.short_bio || "",
        rqe: dp.rqe || "",
        languages: dp.languages ? [...dp.languages] : ["Português"],
        conditionEntries: (dp.condition_entries || []).map(c => ({ ...c })),
        formationEntries: (dp.formation_entries || []).map(f => ({ ...f }))
      };
    },

    saveUser() {
      this.updateUser({
        id: this.currentUser.id,
        name: this.formUser.name,
        email: this.formUser.email,
        phone_number: this.formUser.phone_number,
        birthday: this.toIsoDate(this.formUser.birthday),
        gender: this.formUser.gender
      })
        .then(() => {
          this.$bvToast.toast("Dados atualizados com sucesso.", {
            title: "Sucesso",
            variant: "success",
            solid: true,
            autoHideDelay: 3000
          });
        })
        .catch(() => {
          this.$bvToast.toast("Erro ao atualizar os dados.", {
            title: "Erro",
            variant: "danger",
            solid: true,
            autoHideDelay: 3000
          });
        });
    },

    saveDoctorProfile() {
      this.updateDoctorProperties({
        ...this.dp,
        price_cents: this.formDoctor.price_cents,
        short_bio: this.formDoctor.biography,
        rqe: this.formDoctor.rqe
      })
        .then(() => {
          this.$bvToast.toast("Perfil profissional atualizado com sucesso.", {
            title: "Sucesso",
            variant: "success",
            solid: true,
            autoHideDelay: 3000
          });
        })
        .catch(() => {
          this.$bvToast.toast("Erro ao atualizar o perfil.", {
            title: "Erro",
            variant: "danger",
            solid: true,
            autoHideDelay: 3000
          });
        });
    },

    removeLanguage(lang) {
      this.formDoctor.languages = this.formDoctor.languages.filter(
        l => l !== lang
      );
    },

    addLanguagePrompt() {
      const lang = window.prompt("Idioma:");
      if (
        lang &&
        lang.trim() &&
        !this.formDoctor.languages.includes(lang.trim())
      ) {
        this.formDoctor.languages.push(lang.trim());
      }
    },

    notifyError(message) {
      this.$bvToast.toast(message, {
        title: "Erro",
        variant: "danger",
        solid: true,
        autoHideDelay: 3000
      });
    },

    addCondition() {
      this.newConditionName = "";
      this.addingCondition = true;
    },

    cancelAddCondition() {
      this.addingCondition = false;
      this.newConditionName = "";
    },

    confirmAddCondition() {
      const name = (this.newConditionName || "").trim();
      if (!name) return;

      return Doctor.createConditionEntry(this.dp.id, name)
        .then(({ data }) => {
          this.formDoctor.conditionEntries.push(data);
          this.cancelAddCondition();
        })
        .catch(() => this.notifyError("Erro ao adicionar a condição."));
    },

    removeCondition(condition) {
      const drop = () => {
        this.formDoctor.conditionEntries = this.formDoctor.conditionEntries.filter(
          c => c !== condition
        );
      };

      if (!condition.id) {
        drop();
        return;
      }

      return Doctor.deleteConditionEntry(this.dp.id, condition.id)
        .then(drop)
        .catch(() => this.notifyError("Erro ao remover a condição."));
    },

    askRemoveCondition(condition) {
      this.conditionToRemove = condition;
      this.$bvModal.show("removeConditionModal");
    },

    confirmRemoveCondition() {
      const condition = this.conditionToRemove;
      this.$bvModal.hide("removeConditionModal");
      this.conditionToRemove = null;

      if (condition) this.removeCondition(condition);
    },

    addFormationRow() {
      this.formDoctor.formationEntries.push({
        period: "",
        title: "",
        institution: ""
      });
    },

    saveFormationEntry(entry) {
      const payload = {
        period: entry.period,
        title: entry.title,
        institution: entry.institution
      };

      const request = entry.id
        ? Doctor.updateFormationEntry(this.dp.id, entry.id, payload)
        : Doctor.createFormationEntry(this.dp.id, payload);

      return request
        .then(response => {
          if (!entry.id && response && response.data) {
            entry.id = response.data.id;
          }
          this.$bvToast.toast("Formação salva com sucesso.", {
            title: "Sucesso",
            variant: "success",
            solid: true,
            autoHideDelay: 3000
          });
        })
        .catch(() => this.notifyError("Erro ao salvar a formação."));
    },

    removeFormationEntry(entry) {
      const drop = () => {
        this.formDoctor.formationEntries = this.formDoctor.formationEntries.filter(
          f => f !== entry
        );
      };

      if (!entry.id) {
        drop();
        return;
      }

      return Doctor.deleteFormationEntry(this.dp.id, entry.id)
        .then(drop)
        .catch(() => this.notifyError("Erro ao remover a formação."));
    },

    askRemoveFormationEntry(entry) {
      this.formationEntryToRemove = entry;
      this.$bvModal.show("removeFormationEntryModal");
    },

    confirmRemoveFormationEntry() {
      const entry = this.formationEntryToRemove;
      this.$bvModal.hide("removeFormationEntryModal");
      this.formationEntryToRemove = null;

      if (entry) this.removeFormationEntry(entry);
    },

    deleteAccount() {
      this.$store.dispatch("user/deleteUser").then(() => {
        this.$bvModal.show("accountDeleted");
        setTimeout(() => this.clearLocalSession(), 3500);
      });
    }
  },

  computed: {
    ...mapGetters("user", ["getCurrentUser"]),

    currentUser() {
      return this.getCurrentUser || {};
    },

    dp() {
      return this.currentUser.doctor_property || {};
    },

    isPhysicianCouncil() {
      return !!this.dp.council_name && this.dp.council_name.startsWith("CRM");
    },

    userInitials() {
      const name = this.currentUser.name || "";
      return (
        name
          .split(" ")
          .slice(0, 2)
          .map(n => n[0])
          .join("")
          .toUpperCase() || "?"
      );
    },

    formattedCpf() {
      const raw =
        this.currentUser.cpf || this.currentUser.document_number || "";
      if (!raw || raw === "—") return raw || "—";
      const digits = raw.replace(/\D/g, "");
      if (digits.length !== 11) return raw;
      return digits.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
    }
  },

  watch: {
    currentUser: {
      handler() {
        this.resetUserForm();
        this.resetDoctorForm();
      },
      immediate: true
    }
  }
};
</script>

<style lang="scss" scoped>
.dp-wrap {
  display: flex;
  flex-direction: column;
  height: 100vh;
  background: var(--color-bg-page);
  overflow: hidden;
}

.dp-header {
  flex-shrink: 0;
}

.dp-body {
  flex: 1;
  overflow: hidden;
  display: flex;
  gap: var(--space-6);
  padding: var(--space-6) var(--space-8) var(--space-6) var(--space-8);
}

// Grid: sub-nav 220px + conteúdo flexível
.acct-grid {
  display: contents;
}

// Sub-nav lateral — não scrolla, fica fixo
.acct-nav {
  width: 220px;
  flex-shrink: 0;
  padding: var(--space-2);
  display: flex;
  flex-direction: column;
  gap: 2px;
  overflow-y: auto;
  align-self: flex-start;
  position: sticky;
  top: 0;

  a {
    display: flex;
    align-items: center;
    gap: var(--space-3);
    padding: var(--space-3);
    border-radius: var(--radius-md);
    font-size: var(--font-size-sm);
    font-weight: var(--fw-semibold);
    color: var(--color-gray-600);
    text-decoration: none;
    transition: background 0.12s, color 0.12s;

    &:hover {
      background: var(--color-gray-50);
      color: var(--color-gray-900);
    }

    &.on {
      background: var(--color-primary-light);
      color: var(--color-primary);
    }
  }
}

// Coluna de conteúdo — só ela scrolla
.acct-main {
  flex: 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: var(--space-5);
  padding-bottom: var(--space-12);
}

.acct-sec {
  padding: var(--space-6);

  h2 {
    font-size: var(--font-size-lg);
    font-weight: var(--fw-bold);
    color: var(--color-gray-900);
    margin-bottom: var(--space-1);
  }

  .sub {
    font-size: var(--font-size-sm);
    color: var(--color-gray-500);
    margin-bottom: var(--space-5);
  }
}

// Avatar + nome
.acct-id {
  display: flex;
  align-items: center;
  gap: var(--space-4);
  margin-bottom: var(--space-5);
}

// Grid de campos
.form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--space-4);

  .full {
    grid-column: 1 / -1;
  }
}

// Hint abaixo do input
.hint {
  font-size: var(--font-size-xs);
  color: var(--color-gray-500);
  margin-top: 4px;
  display: block;
}

// Contador de chars
.charcount {
  font-size: var(--font-size-xs);
  color: var(--color-gray-400);
  text-align: right;
  margin-top: 4px;
}

// Textarea
.dp-textarea {
  resize: vertical;
  min-height: 104px;
  font-family: inherit;
  line-height: 1.5;
}

// Chips de idioma
.chip-row {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-2);
  margin-top: var(--space-2);
}

.chip {
  display: inline-flex;
  align-items: center;
  gap: var(--space-2);
  padding: var(--space-2) var(--space-3);
  border: 1px solid var(--color-gray-200);
  border-radius: var(--radius-full);
  font-size: var(--font-size-sm);
  font-weight: var(--fw-semibold);
  color: var(--color-gray-700);
  background: #fff;
}

.chip-x {
  color: var(--color-gray-400);
  font-weight: var(--fw-bold);
  cursor: pointer;
  &:hover {
    color: var(--color-danger);
  }
}

.formation-list {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  margin: var(--space-2) 0;
}

.formation-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-2);

  &__year {
    width: 88px;
    flex: 0 0 auto;
  }

  &__title,
  &__institution {
    flex: 1 1 180px;
    min-width: 0;
  }
}

.inline-add-row {
  display: flex;
  align-items: center;
  margin-top: var(--space-2);

  input {
    width: 300px;
  }

  button {
    margin: 5px;
  }
}

// Linhas de setting (toggle)
.setting-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-4);
  padding: var(--space-4) 0;
  border-bottom: 1px solid var(--color-gray-100);

  &:last-child {
    border-bottom: none;
  }

  .tx {
    display: flex;
    flex-direction: column;
    gap: var(--space-1);

    b {
      font-size: var(--font-size-sm);
      font-weight: var(--fw-semibold);
      color: var(--color-gray-900);
    }

    span {
      font-size: var(--font-size-xs);
      color: var(--color-gray-500);
    }
  }
}

// Toggle switch
.toggle {
  position: relative;
  display: inline-block;
  width: 44px;
  height: 24px;
  flex-shrink: 0;
  cursor: pointer;

  input {
    opacity: 0;
    width: 0;
    height: 0;
    position: absolute;
  }

  .track {
    position: absolute;
    inset: 0;
    border-radius: var(--radius-full);
    background: var(--color-gray-300);
    transition: background 0.2s;

    &::after {
      content: "";
      position: absolute;
      width: 18px;
      height: 18px;
      border-radius: 50%;
      background: #fff;
      top: 3px;
      left: 3px;
      transition: transform 0.2s;
      box-shadow: var(--shadow-sm);
    }
  }

  input:checked + .track {
    background: var(--color-primary);

    &::after {
      transform: translateX(20px);
    }
  }
}

@media (max-width: 860px) {
  .dp-body {
    flex-direction: column;
    overflow-y: auto;
  }

  .acct-nav {
    width: 100%;
    flex-direction: row;
    flex-wrap: wrap;
    overflow-y: visible;
    position: static;
  }

  .acct-main {
    overflow-y: visible;
  }

  .form-grid {
    grid-template-columns: 1fr;
  }
}
</style>
